module.exports = __webpack_public_path__ + "media/images/flags/CN-ce4dc757b1d724c10fab8c42b7b4f5ca.svg";